import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, styled, Box, darken } from '@mui/material';
import { DeviceIconState } from 'console/device/icon/types';
import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { BaseCard, BaseCardLabel } from 'console/shared/styles/mixins/base-card';
const DeviceCard = forwardRef(function DeviceCard(props, ref) {
    return _jsx(BaseCard, { ...props, ref: ref });
});
export const Device = styled(DeviceCard)({
    padding: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
});
function getDeviceNameBackground(device_state, palette) {
    if (device_state === DeviceIconState.alarm) {
        return palette.error.main;
    }
    if (device_state === DeviceIconState.offline) {
        return alpha(palette.action.disabled, 0.3);
    }
    if (device_state === DeviceIconState.guard_zone_alarm ||
        device_state === DeviceIconState.sensor_alarm) {
        return palette.warning.main;
    }
    return palette.background.paper;
}
export const DeviceName = styled(BaseCardLabel)(() => ({
    textAlign: 'center',
}));
export const DeviceContent = styled(motion(Box), {
    shouldForwardProp: (prop) => prop !== 'sorting_mode',
})(({ sorting_mode }) => ({
    padding: 8,
    height: '100%',
    overflow: sorting_mode ? 'hidden' : 'auto',
}));
export const DeviceHeader = styled(Box)(({ theme, device_state }) => {
    const backgroundColor = getDeviceNameBackground(device_state, theme.palette);
    return {
        padding: '8px 16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        columnGap: 16,
        borderBottom: `1px solid ${alpha(theme.palette.action.active, 0.12)}`,
        fontSize: '2rem',
        backgroundColor,
        transition: 'all 0.2s ease-in-out',
        cursor: 'pointer',
        color: device_state == DeviceIconState.sensor_alarm ||
            device_state == DeviceIconState.alarm
            ? theme.palette.common.white
            : theme.palette.text.secondary,
        '&:hover': {
            backgroundColor: darken(backgroundColor, 0.1),
        },
    };
});
